(function() {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Mobile navigation ────────────────────────────────────────────── */
  var toggle = document.getElementById('navToggle');
  var panel = document.getElementById('mobileNav');
  if (toggle && panel) {
    var openIcon = toggle.querySelector('[data-icon="open"]');
    var closeIcon = toggle.querySelector('[data-icon="close"]');
    var setNav = function(open) {
      panel.classList.toggle('hidden', !open);
      toggle.setAttribute('aria-expanded', String(open));
      openIcon.classList.toggle('hidden', open);
      closeIcon.classList.toggle('hidden', !open);
    };
    toggle.addEventListener('click', function() {
      setNav(toggle.getAttribute('aria-expanded') !== 'true');
    });
    panel.addEventListener('click', function(e) {
      if (e.target.closest('a')) setNav(false);
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        setNav(false);
        toggle.focus();
      }
    });
    window.addEventListener('resize', function() {
      if (window.innerWidth >= 1024) setNav(false);
    });
  }

  /* ── Header search ────────────────────────────────────────────────── */
  var searchBtn = document.getElementById('searchToggle');
  var searchPanel = document.getElementById('searchPanel');
  var searchInput = document.getElementById('searchInput');
  var searchClose = document.getElementById('searchClose');
  var setSearch = function(open) {
    if (!searchPanel || !searchBtn) return;
    searchPanel.classList.toggle('hidden', !open);
    searchBtn.setAttribute('aria-expanded', String(open));
    searchBtn.classList.toggle('text-pink', open);
    searchBtn.classList.toggle('text-white/80', !open);
    if (open && searchInput) searchInput.focus();
    // Close mega menus when search opens
    if (open) {
      closeAllMegas();
    }
  };

  if (searchBtn && searchPanel) {
    searchBtn.addEventListener('click', function() {
      var open = searchBtn.getAttribute('aria-expanded') !== 'true';
      setSearch(open);
    });
    if (searchClose) {
      searchClose.addEventListener('click', function() {
        setSearch(false);
        searchBtn.focus();
      });
    }
    searchPanel.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        setSearch(false);
        searchBtn.focus();
      }
    });
    document.addEventListener('click', function(e) {
      if (searchBtn.getAttribute('aria-expanded') !== 'true') return;
      if (!searchPanel.contains(e.target) && !searchBtn.contains(e.target)) {
        setSearch(false);
      }
    });
    // Allow form submission to search page
    // Remove preventDefault to let the form navigate to search page
    // The form action is set to {{ routes.search_url }} in Liquid.
    // We'll just let it submit naturally.
  }

  /* ── Generic multi‑mega menu (desktop & mobile accordion) ──────── */

  // Desktop mega triggers and panels
  var megaTriggers = document.querySelectorAll('[data-mega-trigger]');
  var megaPanels = document.querySelectorAll('[data-mega-panel]');

  // Mobile accordion triggers and panels
  var mobileTriggers = document.querySelectorAll('[data-mobile-trigger]');
  var mobilePanels = document.querySelectorAll('[data-mobile-panel]');

  // ----- Desktop mega menu handler -----
  function closeAllMegas() {
    megaPanels.forEach(function(panel) {
      panel.classList.add('hidden');
    });
    megaTriggers.forEach(function(btn) {
      btn.setAttribute('aria-expanded', 'false');
      var chevron = btn.querySelector('[data-mega-chevron]');
      if (chevron) chevron.classList.remove('rotate-180');
    });
  }

  function toggleMega(triggerId) {
    var trigger = document.querySelector('[data-mega-trigger="' + triggerId + '"]');
    var panel = document.querySelector('[data-mega-panel="' + triggerId + '"]');
    if (!trigger || !panel) return;
    var isOpen = !panel.classList.contains('hidden');
    closeAllMegas();
    if (!isOpen) {
      panel.classList.remove('hidden');
      trigger.setAttribute('aria-expanded', 'true');
      var chevron = trigger.querySelector('[data-mega-chevron]');
      if (chevron) chevron.classList.add('rotate-180');
      // Close search if open
      if (searchPanel && !searchPanel.classList.contains('hidden')) {
        setSearch(false);
      }
    }
  }

  if (megaTriggers.length) {
    // Click toggles
    megaTriggers.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var id = this.dataset.megaTrigger;
        toggleMega(id);
      });
    });

    // Hover intent on pointer devices (desktop only)
    if (window.matchMedia('(hover: hover) and (min-width: 1024px)').matches) {
      var hoverTimer = null;
      megaTriggers.forEach(function(btn) {
        var id = btn.dataset.megaTrigger;
        var panel = document.querySelector('[data-mega-panel="' + id + '"]');
        if (!panel) return;

        var openMega = function() {
          clearTimeout(hoverTimer);
          closeAllMegas();
          panel.classList.remove('hidden');
          btn.setAttribute('aria-expanded', 'true');
          var chevron = btn.querySelector('[data-mega-chevron]');
          if (chevron) chevron.classList.add('rotate-180');
          // Close search
          if (searchPanel && !searchPanel.classList.contains('hidden')) {
            setSearch(false);
          }
        };

        var closeMega = function() {
          clearTimeout(hoverTimer);
          hoverTimer = setTimeout(function() {
            panel.classList.add('hidden');
            btn.setAttribute('aria-expanded', 'false');
            var chevron = btn.querySelector('[data-mega-chevron]');
            if (chevron) chevron.classList.remove('rotate-180');
          }, 180);
        };

        btn.addEventListener('mouseenter', openMega);
        btn.addEventListener('mouseleave', closeMega);
        panel.addEventListener('mouseenter', openMega);
        panel.addEventListener('mouseleave', closeMega);
      });
    }

    // Close on outside click
    document.addEventListener('click', function(e) {
      if (!e.target.closest('[data-mega-trigger]') && !e.target.closest('[data-mega-panel]')) {
        closeAllMegas();
      }
    });

    // Close on Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeAllMegas();
      }
    });
  }

  // ----- Mobile accordion handler -----
  if (mobileTriggers.length) {
    mobileTriggers.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var id = this.dataset.mobileTrigger;
        var panel = document.querySelector('[data-mobile-panel="' + id + '"]');
        if (!panel) return;
        var isOpen = !panel.classList.contains('hidden');
        // Close all other mobile panels
        mobilePanels.forEach(function(p) {
          p.classList.add('hidden');
        });
        mobileTriggers.forEach(function(b) {
          b.setAttribute('aria-expanded', 'false');
          var ch = b.querySelector('[data-mobile-chevron]');
          if (ch) ch.classList.remove('rotate-180');
        });
        if (!isOpen) {
          panel.classList.remove('hidden');
          this.setAttribute('aria-expanded', 'true');
          var ch = this.querySelector('[data-mobile-chevron]');
          if (ch) ch.classList.add('rotate-180');
        }
      });
    });
  }

  /* ── Hero carousel ────────────────────────────────────────────────── */
  var hero = document.getElementById('hero');
  if (hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll('.hero-slide'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-dot]'));
    var index = 0;
    var timer = null;
    var show = function(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function(slide, i) {
        slide.classList.toggle('hidden', i !== index);
      });
      dots.forEach(function(dot, i) {
        dot.classList.toggle('bg-white', i === index);
        dot.classList.toggle('bg-white/40', i !== index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    };
    var start = function() {
      if (reduce) return;
      stop();
      timer = window.setInterval(function() {
        show(index + 1);
      }, 7000);
    };
    var stop = function() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };
    hero.querySelectorAll('[data-hero]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        show(index + (btn.getAttribute('data-hero') === 'next' ? 1 : -1));
        start();
      });
    });
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        show(parseInt(dot.getAttribute('data-hero-dot'), 10));
        start();
      });
    });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', start);
    hero.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        show(index + 1);
        start();
      }
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        show(index - 1);
        start();
      }
    });
    /* Touch swipe */
    var startX = null;
    hero.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
    }, {
      passive: true
    });
    hero.addEventListener('touchend', function(e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 45) {
        show(index + (dx < 0 ? 1 : -1));
        start();
      }
      startX = null;
    }, {
      passive: true
    });
    show(0);
    start();
  }

  /* ── Horizontal product rails ─────────────────────────────────────── */
  document.querySelectorAll('[data-rail]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var rail = document.getElementById(btn.getAttribute('data-rail') + '-rail');
      if (!rail) return;
      var card = rail.querySelector('li');
      var step = card ? card.getBoundingClientRect().width + 10 : rail.clientWidth * 0.8;
      rail.scrollBy({
        left: step * parseInt(btn.getAttribute('data-dir'), 10),
        behavior: reduce ? 'auto' : 'smooth'
      });
    });
  });
  var syncRail = function(rail) {
    var prev = document.querySelector('[data-rail="' + rail.id.replace('-rail', '') + '"][data-dir="-1"]');
    var next = document.querySelector('[data-rail="' + rail.id.replace('-rail', '') + '"][data-dir="1"]');
    var max = rail.scrollWidth - rail.clientWidth - 2;
    if (prev) prev.disabled = rail.scrollLeft <= 2;
    if (next) next.disabled = rail.scrollLeft >= max;
  };
  document.querySelectorAll('.rail').forEach(function(rail) {
    if (!rail.id) return;
    syncRail(rail);
    rail.addEventListener('scroll', function() {
      syncRail(rail);
    }, {
      passive: true
    });
    window.addEventListener('resize', function() {
      syncRail(rail);
    });
  });

})();